var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInvoice = function SvgInvoice(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 17,
    "data-width-36": 26,
    "data-width-72": 52,
    viewBox: "0 0 11.6 12.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 2.25a1.25 1.25 0 0 1 2.5 0v1.417H8zM2.372 1.068C2.876 1.001 3.543 1 4.5 1h2.879A2.24 2.24 0 0 0 7 2.25v8.546l-1.085-.379-.165-.058-.165.058L4 10.971l-1.585-.554-.165-.058-.165.058L1 10.796V4.5c0-.957 0-1.624.068-2.128.066-.49.187-.748.371-.933.185-.184.444-.305.933-.37M9.48.012 9.25 0H4.48c-.92 0-1.66 0-2.24.078-.6.08-1.106.253-1.508.654-.4.402-.573.907-.654 1.507C0 2.821 0 3.561 0 4.48v7.724l.665-.232 1.585-.553 1.585.553.165.057.165-.057 1.585-.553 1.585.553.665.232V4.667h2.477l.06-.001a1 1 0 0 0 .963-1.023V2.25A2.25 2.25 0 0 0 9.48.012M5.666 2.944a.5.5 0 0 0-.5-.5H2.833a.5.5 0 0 0 0 1h2.333a.5.5 0 0 0 .5-.5M2.834 5.89a.5.5 0 0 1 0-1h.583a.5.5 0 1 1 0 1zm2.25 1.944a.5.5 0 0 0-.5-.5h-1.75a.5.5 0 0 0 0 1h1.75a.5.5 0 0 0 .5-.5",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInvoice);
export default ForwardRef;